export const colorBorder = '#F3F3F3';

export const fontNumber = {
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '14px'
};

export const borderProduct = {
  borderBottom: `3px solid ${colorBorder} !important`
};

export const fields = [
  {
    field: 'out',
    name: '使用数'
  },
  {
    field: 'in',
    name: '入荷数'
  },
  {
    field: 'balance',
    name: '在庫'
  }
];

export const stickyCol = (left: number, isHeader: boolean = true) => ({
  position: 'sticky',
  left: `${left}px`,
  backgroundColor: '#FFFFFF',
  zIndex: isHeader ? 200 : 100
});